<template>
  <div class="row" style="width:100%;margin-right:0;margin-left:0;">  
    <div
      class="projectListItem"
      v-for="publicPage in list"
      :key="publicPage.id"
    >
      <PublicPageView :publicPage="publicPage" />
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import PublicPageResp from "@/interface/api/PublicPageResp";
import PublicPageView from "@/component/publicPageList/PublicPageView.vue";

@Options({
  components: {
    PublicPageView,
  },
  props: {
    list: {
      type: Array,
      default: [] 
    },
  },
})
export default class extends Vue {
  readonly list!: Array<PublicPageResp>;
}
</script>



<style lang="scss" scoped>

.projectListItem{

  position: relative;
  width: 100%;
  padding-right: 10px;
  padding-left: 10px;

  @media (min-width: 576px) {
    flex: 0 0 50%;
    max-width: 50%;
  }
  @media (min-width: 768px) {
    flex: 0 0 50%;
    max-width: 50%;
  }
  @media (min-width: 992px) {
    flex: 0 0 33%;
    max-width: 33%;
  }
  @media (min-width: 1200px) {
    flex: 0 0 25%;
    max-width: 25%;
  }
}
</style>